module.exports = __webpack_public_path__ + "img/strategy_bb.80fce8a1.svg";